import React from 'react';
import { ReturnStatus } from '../../../types/stock.types';
import { cn } from '../../../components/ui/utils';

/**
 * Status pill for Return Orders (STOCK.md §5.5).
 *
 * Terminal states (Entered, Voided) are visually heavier than in-flight ones — a
 * yardsman scanning a list needs to see instantly which records can still be worked.
 */
const STYLES: Record<ReturnStatus, { label: string; className: string }> = {
    open: { label: 'Open', className: 'text-slate-700 bg-slate-100' },
    assigned: { label: 'Assigned', className: 'text-blue-700 bg-blue-50' },
    completed: { label: 'Completed', className: 'text-emerald-700 bg-emerald-50' },
    ready_to_enter: { label: 'Ready to Enter', className: 'text-amber-700 bg-amber-50' },
    entered: { label: 'Entered', className: 'text-emerald-800 bg-emerald-100 ring-1 ring-emerald-200' },
    voided: { label: 'Voided', className: 'text-red-700 bg-red-50 ring-1 ring-red-200' },
};

export const ReturnStatusPill: React.FC<{ status: ReturnStatus; className?: string }> = ({
    status,
    className,
}) => {
    const style = STYLES[status] ?? {
        label: String(status).replace(/_/g, ' '),
        className: 'text-slate-700 bg-slate-100',
    };
    return (
        <span className={cn(
            'inline-flex items-center text-xs font-medium px-2 py-1 rounded-md whitespace-nowrap',
            style.className,
            className
        )}>
            {style.label}
        </span>
    );
};

/** Shared label lookup so buttons and pills never drift apart. */
export const statusLabel = (status: ReturnStatus) =>
    STYLES[status]?.label ?? String(status).replace(/_/g, ' ');

export default ReturnStatusPill;
